// extracted by mini-css-extract-plugin
module.exports = {"heading":"SocialLoginButtons_heading__3JwKR","idpButtons":"SocialLoginButtons_idpButtons__1wDff"};